import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { createLazyOrchestrator } from 'owa-bundling';
import { lazyShowFullComposeInEditMode } from 'owa-calendar-compose-form-store';
import getDefaultStart from 'owa-calendar-forms-common/lib/utils/getDefaultStart';
import { FULL_COMPOSE_VIEW_TYPE_MODAL } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { launchNewEvent } from 'owa-calendar-module-commanding';
import { isBoardViewTypeSelected } from 'owa-calendar-module-store';
import { tryShowQuickCompose } from 'owa-calendar-quick-compose/lib/actions/tryShowQuickCompose';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { isEqual, OwaDate, today } from 'owa-datetime';
import { DateRange } from 'owa-datetime-utils';
import EventScope from 'owa-service/lib/contract/EventScope';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import {
    QuickComposeEntrySourceType,
    FullComposeEntrySourceType,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// Each view type should expose a handler for conditional registration

export const launchNewEventOrchestrator = createLazyOrchestrator(
    launchNewEvent,
    'launchNewEvent_CLONE',
    actionMessage => {
        const { entrySource, anchor } = actionMessage;
        if (isBoardViewTypeSelected()) {
            const selectedDate = today();
            const dateRange = { start: selectedDate, end: selectedDate };
            launchNewEventHelper(
                dateRange,
                undefined /* dateRangeType */,
                selectedDate,
                entrySource,
                anchor
            );
        } else {
            const surfaceStore = getSurfaceStore();
            launchNewEventHelper(
                surfaceStore.dateRange,
                surfaceStore.dateRangeType,
                surfaceStore.selectedDate,
                entrySource,
                anchor
            );
        }
    }
);

/**
 * Opens the quick-compose or full-compose form for creating a new event, depending on user context
 *
 * @param dateRange current date range
 * @param dateRangeType current date range type
 * @param selectedDate selected date
 * @param entrySource indicates how the form was entered
 * @param anchor anchor for quick compose form
 */
function launchNewEventHelper(
    dateRange: DateRange,
    dateRangeType: DateRangeType | undefined,
    selectedDate: OwaDate,
    entrySource: QuickComposeEntrySourceType & FullComposeEntrySourceType,
    anchor: HTMLDivElement | string
) {
    let initialCalendarEvent: CalendarEvent = null;

    // if the user is in month view, then use the selected date as the initialCalendarEvent date
    if (dateRangeType === DateRangeType.Month) {
        initialCalendarEvent = {
            Start: getDefaultStart(selectedDate),
            IsAllDayEvent: false,
        } as CalendarEvent;
    }

    if (isConsumer()) {
        tryShowQuickCompose(initialCalendarEvent, entrySource, EventScope.Default, anchor);
    } else {
        const startDate = dateRange.start;
        const endDate = dateRange.end;

        // If showing only one day (either one day in WEEK view or DAY view) then use initialCalendarEvent date
        if (isEqual(startDate, endDate)) {
            initialCalendarEvent = {
                Start: getDefaultStart(startDate),
                IsAllDayEvent: false,
            } as CalendarEvent;
        }
        lazyShowFullComposeInEditMode.importAndExecute(
            initialCalendarEvent,
            EventScope.Default,
            false /* itemHasUpdates */,
            entrySource,
            FULL_COMPOSE_VIEW_TYPE_MODAL,
            null /* extractionSourceId */
        );
    }
}
